<template>
  <div class="container">
    <div class="block">
      <el-form size="mini" :model="searchInfo" inline>
        <div class="radio-group" style="flex: 1">
          <div
            :class="`mwow-button large${
              searchInfo.range === 'today' ? ' success' : ''
            }`"
            @click="searchRangeChange('today')"
          >
            今天
          </div>
          <div
            :class="`mwow-button large${
              searchInfo.range === 'yesterday' ? ' success' : ''
            }`"
            @click="searchRangeChange('yesterday')"
          >
            昨日
          </div>
          <div
            :class="`mwow-button large${
              searchInfo.range === 'week' ? ' success' : ''
            }`"
            @click="searchRangeChange('week')"
          >
            本周
          </div>
          <div
            :class="`mwow-button large${
              searchInfo.range === 'lastMonth' ? ' success' : ''
            }`"
            @click="searchRangeChange('lastMonth')"
          >
            上月
          </div>
          <div
            :class="`mwow-button large${
              searchInfo.range === 'month' ? ' success' : ''
            }`"
            @click="searchRangeChange('month')"
          >
            本月
          </div>
          <div
            :class="`mwow-button large${
              searchInfo.range === 'year' ? ' success' : ''
            }`"
            @click="searchRangeChange('year')"
          >
            本年
          </div>
        </div>
        <el-form-item label="统计时间:">
          <common-date-range-selector
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            value-format="yyyy-MM-dd"
            v-model="searchInfo.date"
            clearable
            @change="searchDateChange(searchInfo.date)"
            :picker-options="enterDateOptions"
          >
          </common-date-range-selector>
        </el-form-item>
        <el-button
          class="mwow-button-filled success"
          @click="handleSearch"
          v-debounce="1000"
          >查询</el-button
        >
        <el-button
          class="mwow-button-filled primary"
          @click="handleExport"
          v-debounce="1000"
          >导出</el-button
        >
      </el-form>
    </div>
    <div class="block">
      <div
        class="datas"
        v-for="(item, index) in comprehensiveData"
        :key="index"
      >
        <div class="title">
          <p>
            {{ item.title }}
          </p>
          <el-popover
            v-if="item.n === 5"
            placement="top"
            width="230"
            popper-class="followuppopover"
            trigger="hover"
          >
            <div>查询时间内，校区新入学学员不计算在内</div>
            <div class="question" slot="reference">
              <div>?</div>
            </div>
          </el-popover>
        </div>
        <div class="data-item">
          <div
            :class="it.route_name !== '' ? 'item high-light' : 'item'"
            v-for="(it, ind) in item.arr"
            :key="ind"
          >
            <div class="item-top">
              <p>
                {{ it.name }}
              </p>
              <el-popover
                placement="top"
                width="230"
                popper-class="followuppopover"
                trigger="hover"
              >
                <div>
                  {{ it.popover }}
                </div>
                <div class="question" slot="reference">
                  <div>?</div>
                </div>
              </el-popover>
            </div>
            <div class="item-bottom">{{ it.num }}</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import {
  dateFormat,
  getLastMonth,
  getCurrentMonth,
  getCurrentWeek,
} from "@/utils/timeFormat";
import { comDataApi } from "@/api/statistics";
import { roundNumbers } from "@/utils/roundNumbers";
import { createOperationLogApi } from "@/api/store";
import json2csv from "json2csv";
import commonDateRangeSelector from "@/components/commonDateRangeSelector.vue";

export default {
  components: {
    commonDateRangeSelector,
  },
  data() {
    return {
      currentTimeType: "day",
      currentTimeRange: [],
      searchInfo: {
        date: [],
        range: "today",
      },
      comprehensiveData: [],
      exportTableData: [],
      enterDateOptions: {
        disabledDate: (time) => {
          return time.getTime() > new Date();
        },
      },
    };
  },

  created() {
    this.searchRangeChange("month");
  },
  methods: {
    searchRangeChange(type) {
      let start = "";
      let end = "";
      const now = new Date();
      this.currentTimeType = "day";
      switch (type) {
        case "today":
          start = dateFormat("YYYY-mm-dd", now);
          end = dateFormat("YYYY-mm-dd", now);
          break;
        case "yesterday":
          start = dateFormat("YYYY-mm-dd", now.getTime() - 24 * 60 * 60 * 1000);
          end = dateFormat("YYYY-mm-dd", now.getTime() - 24 * 60 * 60 * 1000);
          break;
        case "week":
          const week = getCurrentWeek(now);
          start = dateFormat("YYYY-mm-dd", week[0]);
          end = dateFormat(
            "YYYY-mm-dd",
            dateFormat("YYYY-mm-dd", now.getTime())
          );
          break;
        case "lastMonth":
          const lastMonth = getLastMonth(now);
          start = dateFormat("YYYY-mm-dd", lastMonth[0]);
          end = dateFormat("YYYY-mm-dd", lastMonth[1]);
          break;
        case "month":
          const monthArr = getCurrentMonth(now);
          start = dateFormat("YYYY-mm-dd", monthArr[0]);
          end = dateFormat("YYYY-mm-dd", now);
          break;
        case "year":
          start = `${now.getFullYear()}-01-01`;
          end = dateFormat("YYYY-mm-dd", now);
          break;
      }
      this.currentTimeRange = [start, end];
      this.searchInfo.range = type;
      this.searchInfo.date = [start, end];
      this.getList({
        start_date: this.currentTimeRange[0],
        end_date: this.currentTimeRange[1],
      });
    },
    searchDateChange(dates) {
      if (!dates) {
        // 清除
        this.searchInfo.range = "month";
        this.currentTimeRange = [];
        this.searchRangeChange("month");
      } else {
        this.searchInfo.range = "free";
        if (this.searchInfo.date.length > 0) {
          this.currentTimeRange = this.searchInfo.date;
          this.getList({
            start_date: this.currentTimeRange[0],
            end_date: this.currentTimeRange[1],
          });
        }
      }
    },
    getList(params) {
      comDataApi(params).then((res) => {
        if (res.error_code === 0) {
          const _d = res.data;
          this.exportTableData = [_d];
          this.comprehensiveData = [];
          const storeArr = {
            title: "门店数据",
            n: 1,
            arr: [
              {
                name: "门店净收入",
                popover: "门店总收入-门店总支出",
                num: _d.total_net_income_amount,
                route_name: "",
                key: "",
              },
              {
                name: "门店总收入",
                popover: "门店课程、物品服务等所有收入合计",
                num: _d.total_buy_amount,
                route_name: "",
                key: "",
              },
              {
                name: "门店总支出",
                popover: "门店退课程、退物品服务等所有支出合计",
                num: _d.total_refund_amount,
                route_name: "",
                key: "",
              },
            ],
          };
          const studentArr = {
            title: "学员数据",
            n: 2,
            arr: [
              {
                name: "新增学员数",
                popover: "第一次购课的学员数;",
                num: _d.new_on_going_num,
                route_name: "",
                key: "",
              },
              {
                name: "可续费学员人数",
                popover:
                  "已报读课程，剩余课时≤提醒续费设置数量的学员人数,按学员去重;",
                num: _d.renewable_num,
                route_name: "",
                key: "",
              },
              {
                name: "续费学员人数",
                popover: "已报读课程再次续费的学员数,按学员去重;",
                num: _d.renew_num,
                route_name: "",
                key: "",
              },
              {
                name: "续费学员转化率",
                popover: "续费学员转化率=续费学员人数/在读学员数*100%;",
                num: roundNumbers(_d.renew_rate) + "%",
                route_name: "",
                key: "",
              },
              {
                name: "在读学员数",
                popover: "查询时间最后一刻的在读学员人数;",
                num: _d.on_going_num,
                route_name: "",
                key: "",
              },
              {
                name: "名单数",
                popover: "新录入的有意向学员数;",
                num: _d.roster_num,
                route_name: "",
                key: "",
              },
              {
                name: "到访人数",
                popover: "录入了到访跟进记录的意向学员人数,按学员去重;",
                num: _d.visited_num,
                route_name: "",
                key: "",
              },
              {
                name: "完成体验人数",
                popover: "所有完成体验的意向学员人数,按学员去重;",
                num: _d.experience_finish_num,
                route_name: "",
                key: "",
              },
              {
                name: "体验转化率",
                popover:
                  "体验转化率=体验转化人数/完成体验人数*100%(统计未读意向学员数据);",
                num: roundNumbers(_d.experience_transform_rate) + "%",
                route_name: "",
                key: "",
              },
              {
                name: "学员提交作业率",
                popover:
                  "学员提交作业率: 学员提交作业率=学员实际提交作业数/教师实际发布作业数量(已发布作业的学员数量)*100%;",
                num: roundNumbers(_d.homework_commit_rate) + "%",
                route_name: "",
                key: "",
              },
            ],
          };
          const courseArr = {
            title: "课程数据",
            n: 3,
            arr: [
              {
                name: "课程收入合计",
                popover:
                  "课程收入合计: 课程收入合计=购买课程收入金额+转入课程收入合计+转出课程支出金额+退款课程支出金额;",
                num: _d.course_receivable_amount, // 收入有可能为负数
                route_name: "",
                key: "",
              },
              {
                name: "耗课收入金额",
                popover: "耗课收入金额: 耗掉课程的课时所对应的金额;",
                num: roundNumbers(_d.course_consume_amount),
                route_name: "",
                key: "",
              },
              {
                name: "新签金额",
                popover: "新签金额: 新学员的第一笔消费金额;",
                num: roundNumbers(_d.first_order_amount),
                route_name: "",
                key: "",
              },
              {
                name: "续费金额",
                popover: "续费金额: 已报读课程再次续费的金额;",
                num: roundNumbers(_d.renew_amount),
                route_name: "",
                key: "",
              },
              {
                name: "拓科金额",
                popover: "已报读课程再次拓科金额;",
                num: roundNumbers(_d.expand_amount),
                route_name: "",
                key: "",
              },
              {
                name: "客单价",
                popover: "客单价: 客单价=学员支付订单金额的/学员数;",
                num: roundNumbers(_d.average_amount),
                route_name: "",
                key: "",
              },
              {
                name: "未耗课金额",
                popover: "门店所有学员的购课档案剩余课时金额之和;",
                num: roundNumbers(_d.course_unconsume_amount),
                route_name: "",
                key: "",
              },
            ],
          };
          const teacherClassArr = {
            title: "教师班级数据",
            n: 3,
            arr: [
              {
                name: "班容",
                popover: "班容: 班容=耗课数/开班数;",
                num: roundNumbers(_d.class_size),
                route_name: "",
                key: "",
              },
              {
                name: "耗课数",
                popover: "耗课数: 学员上课已消耗的课时数;",
                num: _d.real_consume_num,
                route_name: "",
                key: "",
              },
              {
                name: "教师作业发布率",
                popover:
                  "教师作业发布率: 教师发布作业率=教师实际发布作业数量（已发布作业的学员数量）/教师应该发布作业数量（上课已签到学员数）*100%;",
                num: roundNumbers(_d.homework_publish_rate) + "%",
                route_name: "",
                key: "",
              },
              {
                name: "开班数",
                popover:
                  "开班数: 有耗课的课次数 (按照班级课次数累计,例如本周内A班级耗了3课次数，B班级耗了6课次数，本周开班数为9);",
                num: roundNumbers(_d.class_num),
                route_name: "",
                key: "",
              },
              {
                name: "1vN开班数",
                popover:
                  "1vN开班数：有消耗集体课的课次数（按照班级集体课次数累计，例如本周内A班级耗了集体课3课次数，B班级耗了集体课6课次数，本周集体课开班数为9);",
                num: roundNumbers(_d.class_num_1vn),
                route_name: "",
                key: "",
              },
            ],
          };
          const otherArr = {
            title: "其他收入",
            n: 4,
            arr: [
              {
                name: "其他收入合计",
                popover: "物品服务收入合计-物品服务支出合计",
                num: _d.total_product_amount,
                route_name: "",
                key: "",
              },
              {
                name: "物品收入合计",
                popover: "所有物品类别的收入合计",
                num: _d.product_buy_amount,
                route_name: "",
                key: "",
              },
              {
                name: "服务收入合计",
                popover: "所有服务类别的收入合计+非课程活动收入",
                num: _d.service_product_buy_amount,
                route_name: "",
                key: "",
              },
              {
                name: "物品支出合计",
                popover: "所有物品类别的退款合计",
                num: _d.product_refund_amount,
                route_name: "",
                key: "",
              },
              {
                name: "服务支出合计",
                popover: "所有服务类别的退款合计",
                num: _d.service_product_refund_amount,
                route_name: "",
                key: "",
              },
            ],
          };
          const beginStudentArr = {
            title: "期初学员数据",
            n: 5,
            arr: [
              {
                name: "期初在读学员数",
                popover: "查询开始日期零点的在读学员人数，按学员去重；",
                num: _d.begin_student_data.ongoing_student_num,
                route_name: "",
                key: "",
              },
              {
                name: "活跃人数",
                popover:
                  "期初在读学员，在查询时间内有耗课的学员数，按学员去重；",
                num: _d.begin_student_data.active_student_num,
                route_name: "",
                key: "",
              },
              {
                name: "活跃率",
                popover: "活跃率=活跃人数/期初在读学员数*100%",
                num: roundNumbers(_d.begin_student_data.active_rate) + "%",
                route_name: "",
                key: "",
              },
              {
                name: "期初学员耗课数",
                popover: "期初在读学员，在查询时间内耗课数总计；",
                num: roundNumbers(_d.begin_student_data.consume_lesson_count),
                route_name: "",
                key: "",
              },
              {
                name: "周系数",
                popover: "周系数=（查询时间天数-假期天数）/7；",
                num: roundNumbers(_d.week_coefficient),
                route_name: "",
                key: "",
              },
              {
                name: "耗课频次",
                popover: "耗课频次=期初学员耗课数/期初在读学员数/周系数；",
                num: roundNumbers(_d.begin_student_data.consume_frequency),
                route_name: "",
                key: "",
              },
            ],
          };
          this.comprehensiveData.push(
            storeArr,
            courseArr,
            otherArr,
            studentArr,
            teacherClassArr,
            beginStudentArr
          );
        }
      });
    },
    handleSearch() {
      this.getList({
        start_date: this.searchInfo.date[0],
        end_date: this.searchInfo.date[1],
      });
    },
    handleClear() {
      this.searchInfo.range = "month";
      this.searchRangeChange("month");
    },
    handleExport() {
      try {
        const result = json2csv.parse(
          [
            {
              total_net_income_amount: "门店净收入",
              total_buy_amount: "门店总收入",
              total_refund_amount: "门店总支出",
              new_on_going_num: "新增学员数",
              renewable_num: "可续费学员数量",
              renew_num: "续费学员数量",
              renew_rate: "续费学员转化率",
              on_going_num: "在读学员数",
              roster_num: "名单数",
              visited_num: "到访数",
              experience_finish_num: "体验学员数",
              experience_transform_rate: "体验转化率",
              homework_commit_rate: "学员提交作业率",
              course_receivable_amount: "课程收入合计",
              course_consume_amount: "耗课收入金额",
              first_order_amount: "新签金额",
              renew_amount: "续费金额",
              expand_amount: "拓科金额",
              average_amount: "客单价",
              course_unconsume_amount: "未耗课金额",
              class_size: "班容",
              real_consume_num: "耗课数",
              homework_publish_rate: "教师作业发布率",
              class_num: "开班数",
              total_product_amount: "其他收入合计",
              product_buy_amount: "物品收入合计",
              service_product_buy_amount: "服务收入合计",
              product_refund_amount: "物品支出合计",
              service_product_refund_amount: "服务支出合计",
              "begin_student_data.ongoing_student_num": "期初在读学员数",
              "begin_student_data.active_student_num": "活跃人数",
              "begin_student_data.active_rate": "活跃率",
              "begin_student_data.consume_lesson_count": "期初学员耗课数",
              week_coefficient: "周系数",
              "begin_student_data.consume_frequency": "耗课频次",
            },
            ...this.exportTableData,
          ],
          {
            fields: [
              "total_net_income_amount",
              "total_buy_amount",
              "total_refund_amount",
              "new_on_going_num",
              "renewable_num",
              "renew_num",
              "renew_rate",
              "on_going_num",
              "roster_num",
              "visited_num",
              "experience_finish_num",
              "experience_transform_rate",
              "homework_commit_rate",
              "course_receivable_amount",
              "course_consume_amount",
              "first_order_amount",
              "renew_amount",
              "expand_amount",
              "average_amount",
              "course_unconsume_amount",
              "class_size",
              "real_consume_num",
              "homework_publish_rate",
              "class_num",
              "total_product_amount",
              "product_buy_amount",
              "service_product_buy_amount",
              "product_refund_amount",
              "service_product_refund_amount",
              "begin_student_data.ongoing_student_num",
              "begin_student_data.active_student_num",
              "begin_student_data.active_rate",
              "begin_student_data.consume_lesson_count",
              "week_coefficient",
              "begin_student_data.consume_frequency",
            ],
            header: false,
          }
        );
        //非IE浏览器
        const csvContent = "data:text/csv;charset=utf-8,\uFEFF" + result;
        //使用a标签的download属性实现下载功能
        const link = document.createElement("a");
        link.href = encodeURI(csvContent);
        link.download =
          "门店综合数据[" +
          this.currentTimeRange[0] +
          " ~ " +
          this.currentTimeRange[1] +
          "].csv";
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        createOperationLogApi({
          code: 10505,
          detail: "导出门店综合数据",
        });
        this.$message({
          message: "导出成功",
          type: "success",
        });
      } catch (err) {
        this.$message({
          type: "error",
          message: err.toString(),
        });
      }
    },
  },
};
</script>
<style scoped lang="scss">
.container {
  .block {
    background: #ffffff;
    border-radius: 4px;
    margin-bottom: 12px;
    padding: 15px 12px;
    overflow-x: hidden;
    .radio-group {
      display: inline-block;
      margin-right: 20px;
      .mwow-button {
        margin-left: 12px;
      }
    }
    .datas {
      margin: 10px 0;
      color: #5c5d5e;
      .title {
        display: flex;
        align-items: center;
        font-size: 12px;
        margin-bottom: 10px;
        //width: 100px;
      }
      .data-item {
        flex: 1;
        width: 100%;
        display: flex;
        flex-wrap: wrap;
        .item {
          min-width: 130px;
          padding: 10px;
          text-align: center;
          box-sizing: border-box;
          width: 103px;
          background: #f6fafc;
          border-right: 1px solid #f1f2f2;
          &:last-child {
            border-right: none;
          }
          .item-top {
            margin-bottom: 5px;
            font-size: 12px;
            display: flex;
            align-items: center;
            justify-content: center;
            p {
              position: relative;
              top: 1px;
            }
          }
          .item-bottom {
            font-size: 18px;
            font-weight: 700;
          }
          &.high-light {
            cursor: pointer;
            &:hover {
              border: 1px solid #07d1aa !important;
              background: #f0fdfa !important;
            }
          }
        }
      }
    }
  }
}
</style>
